module.exports = __webpack_public_path__ + "static/media/d60e7501-b415-4d05-ada4-a5050a8c0704.61133fc8.jpg";